
<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 80vh;">
    <p class="Titulo">Consulta - Área</p>
    <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;"
      (click)="consultarAreaConsulta()">
      <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
    </button>
    <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
    <div>
       <!--<div *ngIf="showAreaConsulta">
        <angular-slickgrid gridId="gridAreaConsulta" [columnDefinitions]="columnDefinitionsAreaConsulta"
          [gridOptions]="gridOptionsAreaConsulta" [dataset]="datasetAreaConsulta" gridHeight="380" gridWidth="100%"
          (onAngularGridCreated)="angularGridReadyAreaConsulta($event)">
        </angular-slickgrid> 
      </div>-->
        <div *ngIf="showAreaConsulta">
        <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetAreaConsulta"
            [columnDefs]="columnDefinitionsAreaConsulta"
            (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true" />
        </div>
    </div>
    <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showAreaConsulta"
      [disabled]="!showAreaConsulta" (click)="exportToExcelArea()">
      <nb-icon icon="save-outline"></nb-icon>Exportar
    </button>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive
    style="height: 80vh;">
    <div class="row">
      <div class="col-4 float-left">
        <p class="Titulo">Alta Área</p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción</mat-label>
            <input matInput #message1 maxlength="80" [(ngModel)]="descripcionArea" name="descripcion">
            <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción Breve</mat-label>
            <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreve" name="breve">
            <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Código Externo</mat-label>
            <input matInput #message3 maxlength="40" [(ngModel)]="codigoExterno" name="codigo">
            <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
          <button *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz"
            (click)="altaArea()">Guardar</button>
        </p>
      </div>
      <div>
        <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarArea()">
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner class="float-right col-6" *ngIf="showSpinner"></app-spinner>
        <!-- <div *ngIf="showArea" class="float-right col-6">
       <angular-slickgrid gridId="gridArea" [columnDefinitions]="columnDefinitionsArea" [gridOptions]="gridOptionsArea"
          [dataset]="datasetArea" gridHeight="380" (onAngularGridCreated)="angularGridReadyArea($event)">
        </angular-slickgrid> 
      </div> -->
        <div *ngIf="showArea" class="float-right col-6">
         <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetArea"
            [columnDefs]="columnDefinitionsArea" 
            (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true"
            />
        </div>
    </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive
    style="height: 75vh;">
    <p class="Titulo">Modificar Área</p>
    <p-dropdown required class="limited-selector" id="inputArea" placeholder="Seleccionar Área"
      [style]="{'width':'20%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="area" [(ngModel)]="areaProcesada"
      (onChange)="obtenerDescripcionDropdown(areaProcesada)" [virtualScroll]="true" [itemSize]="31" [filter]="true"
      [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
    </p-dropdown>
    <div class="row">
      <div class="col-4 float-left">
        <p>
          <mat-form-field class="altaLabelModificacion">
            <mat-label>Descripcion</mat-label>
            <input matInput #message4 maxlength="80" [(ngModel)]="descripcionAreaEditar" name="descripcionAreaEditar">
            <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabelModificacion">
            <mat-label>Descripcion Breve</mat-label>
            <input matInput #message5 maxlength="40" [(ngModel)]="descripcionBreveEditar" name="descripcionBreveEditar">
            <mat-hint align="end">{{message5.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabelModificacion">
            <mat-label>Código Externo</mat-label>
            <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditar" name="codigoExternoEditar">
            <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar
          </nb-checkbox>
        </p>
       
        <p>
          <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
          <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class="buttontz"
            (click)="modificarArea()">Modificar</button>
        </p>
      </div>
      <div>
        <button nbButton shape="round" size="small" class="buttontz float-right" style="margin-top: -95px"
          (click)="consultarAreaModificar()">
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner *ngIf="showSpinnerModificarGrilla" style="margin-left: 250px"></app-spinner>
      <div class="col-6 float-right" *ngIf="showAreaModificar">
        <!-- <angular-slickgrid gridId="gridAreaModificar" [columnDefinitions]="columnDefinitionsAreaModificar"
          [gridOptions]="gridOptionsAreaModificar" [dataset]="datasetAreaModificar" gridHeight="380" gridWidth="100%"
          (onAngularGridCreated)="angularGridReadyAreaConsulta($event)">
        </angular-slickgrid> -->

          <ag-grid-angular
            #grilla3
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetAreaModificar"
            [columnDefs]="columnDefinitionsAreaModificar"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
      
      </div>
    </div>
  </nb-tab>
</nb-tabset>